import { CompanyProfile } from 'models';
import { CollectionHelpers } from 'src/helpers/CollectionHelpers';

import { useFile } from 'hooks/use-file';
import { useIndustryCategories } from 'hooks/use-industry-categories';

const useCompanyCoverImage = (company: CompanyProfile) => {
    const { subCategories } = useIndustryCategories();

    const image =
        company.cover ||
        company.industrySubcategories
            ?.map((category) => subCategories.find(({ id }) => id === category))
            .find((subcategory) => subcategory?.image)?.image;

    const { file } = useFile(image);

    const { file: coverVideo } = useFile(CollectionHelpers.id(company.coverVideo));

    return {
        image: file,
        coverType: company.coverType || 'image',
        videoUrl: coverVideo.url,
        youTubeUrl: company.coverYouTubeVideo,
    };
};

export { useCompanyCoverImage };
